import type { managePilots as en } from '@/i18n/locales/en/managePilots';
import type { Translation } from '@/i18n/types';

export const managePilots: Translation<typeof en> = {
  page: {
    title: 'Pilotlar',
    lead: 'Platformdaki tüm pilotlar, şirkete ve duruma göre filtrelenebilir.',
    filterCompany: 'Şirket',
    filterStatus: 'Durum',
    allCompanies: 'Tüm şirketler',
    allStatuses: 'Tüm durumlar',
    empty: 'Bu filtrelere uyan pilot yok.',
    rowsLabel: 'pilotlar',
    company: 'Şirket',
    name: 'Ad',
    status: 'Durum',
    startDate: 'Başlangıç tarihi',
    endDate: 'Bitiş tarihi',
    departments: 'Departmanlar',
  },
  status: {
    draft: 'Taslak',
    baseline: 'Başlangıç ölçümü',
    active: 'Aktif',
    interim_review: 'Ara değerlendirme',
    final_review: 'Son değerlendirme',
    completed: 'Tamamlandı',
    scaled: 'Ölçeklendirildi',
  },
};
